<template>
    <div>
        <card-header icon="fa-user">
            <template #title>
                <span class="is-clickable" @click="$copyText(user.first_name + ' ' + user.last_name + ' (' + user.id + ')')">
                    {{ user.first_name }} {{ user.last_name }}
                </span>
            </template>
        </card-header>

        <div v-if="user.suspension_message" class="suspension-banner">
            <div class="suspension-inner">
                <div class="suspension-icon"><i class="fas fa-ban"></i></div>
                <div class="suspension-body">
                    <div class="suspension-title">Account Suspended</div>
                    <div class="suspension-text">{{ user.suspension_message }}</div>
                </div>
            </div>
        </div>

        <card-toolbar v-if="currentUser.isSuper">
            <b-tooltip label="Login">
                <button class="icon-only" @click="getToken"><i class="far fa-arrow-right-to-arc"></i></button>
            </b-tooltip>
            <b-tooltip label="Edit User">
                <button class="icon-only" @click="$openCard('user-edit', {userId: user.id}, card)"><i class="fal fa-pencil"></i></button>
            </b-tooltip>
<!--            <b-tooltip label="New Note">-->
<!--                <button class="icon-only"><i class="far fa-comment-alt-plus"></i></button>-->
<!--            </b-tooltip>-->
<!--            <b-tooltip label="New Support Ticket">-->
<!--                <button class="icon-only"><i class="far fa-envelope-open-text"></i></button>-->
<!--            </b-tooltip>-->
            <b-tooltip label="Merge User" v-if="currentUser.isSuper">
                <button class="icon-only" @click="$openCard('user-merge', {userId: user.id}, card)"><i class="far fa-merge"></i></button>
            </b-tooltip>
            <button @click="$openCard('new-enrollment', {userId: props.userId}, card)"><i class="far fa-plus"></i>New Enrollment</button>


            <template v-slot:right>
                <b-tooltip label="Classic Login">
                    <button class="icon-only" @click="openLink('https://www.my247ed.com/admin/users/doLogin.php?u=' + user.email)"><i class="far fa-sign-in"></i></button>
                </b-tooltip>
                <b-tooltip label="Classic Details">
                    <button class="icon-only" @click="openLink('https://www.my247ed.com/admin/users/details.php?id=' + user.id)"><i class="far fa-external-link"></i></button>
                </b-tooltip>
                <b-tooltip :label="user.has_legacy_access ? 'New Legacy Access Link (copies)' : 'Grant Legacy Access (copies link)'">
                    <button class="icon-only" @click="grantLegacyAccess"><i class="far fa-key" :class="{'has-text-success': user.has_legacy_access}"></i></button>
                </b-tooltip>
                <b-tooltip label="Revoke Legacy Access" v-if="user.has_legacy_access">
                    <button class="icon-only" @click="revokeLegacyAccess"><i class="far fa-link-slash"></i></button>
                </b-tooltip>
            </template>
        </card-toolbar>

        <card-body>
            <data-row title="Full Name">
                <span class="is-clickable" @click="$copyText(user.first_name + ' ' + user.last_name)">{{ (user.title ? user.title + ' ' : '') }}{{ user.first_name }} {{ user.last_name }}</span>
            </data-row>
            <data-row title="Maiden Name"><span class="is-clickable" @click="$copyText(user.maiden_name)">{{ user.maiden_name }}</span></data-row>
            <data-row title="Gender">{{ user.gender }}</data-row>
            <data-row title="E-Mail Address"><span class="is-clickable" @click="$copyText(user.email)">{{ user.email }}</span></data-row>
            <data-row title="Alt E-Mail"><span class="is-clickable" @click="$copyText(user.email_2)">{{ user.email_2 }}</span></data-row>
            <data-row title="Home Phone"><span class="is-clickable" @click="$copyText(user.phone)">{{ user.phone | tel }}</span></data-row>
            <data-row title="Work Phone"><span class="is-clickable" @click="$copyText(user.phone_2)">{{ user.phone_2 | tel }}</span></data-row>
            <data-row title="Address">
                <div class="is-clickable" @click="$copyText(user.address + ((user.address_2)?', '+user.address_2:', ') + user.city + ', ' + user.state + ' ' + user.zip)">
                    <div>{{ user.address }}</div>
                    <div v-if="user.address_2">{{ user.address_2 }}</div>
                    <div>{{ user.city }}, {{ user.state }} &nbsp;{{ user.zip }}</div>
                </div>
            </data-row>
            <data-row title="Date of Birth">{{ user.dob | moment('MMMM Do, YYYY') }}<br>{{ user.dob | moment('from', 'now', true) }} old</data-row>

            <data-row title="Grade Level">{{ user.grade_level }}</data-row>
            <data-row title="Subject">{{ user.subject_area }}</data-row>
            <data-row title="School">{{ user.school }}</data-row>
            <data-row title="District">{{ user.district }}</data-row>

            <data-row title="Referral">{{ user.referral }}</data-row>
            <data-row title="Assigned Reseller">{{user.assigned_reseller_user ? `${user.assigned_reseller_user.first_name} ${user.assigned_reseller_user.last_name}` : ''}}</data-row>
            <data-row title="Registration Date">{{ user.created_at | moment('MMM Do, YYYY h:mm A') }}</data-row>
            <data-row title="Last Login Date">{{ user.last_login_at | moment('MMM Do, YYYY h:mm A') }}</data-row>
            <data-row title="Info Verified">
                <span v-if="user.profile_verified_at">
                    {{ user.profile_verified_at | moment('MMM Do, YYYY') }}
                    <span class="has-text-grey">({{ user.profile_verified_at | moment('from', 'now') }})</span>
                </span>
                <span v-else class="has-text-danger">Never</span>
                <div v-if="user.profile_prompt_dismissals" class="is-size-7 has-text-grey">
                    Reminder snoozed {{ user.profile_prompt_dismissals }}x<span v-if="user.profile_prompt_snoozed_at">, last {{ user.profile_prompt_snoozed_at | moment('from', 'now') }}</span>
                </div>
            </data-row>
            <data-row title="User ID"><span class="is-clickable" @click="$copyText(user.id)">{{ user.id }}</span></data-row>

            <card-list v-if="currentUser.isSuper">
                <separator-list-item />

                <navigation-list-item
                    title="Support Tickets"
                    icon="fa-life-ring"
                    @click="$openCard('user-ticket-list', {userId: user.id}, card)"
                    :active="isActive('user-ticket-list')"
                />

                <navigation-list-item
                    title="Activity"
                    icon="fa-globe-pointer"
                    @click="$openCard('user-activity', {userId: user.id}, card)"
                    :active="isActive('user-activity')"
                />

                <navigation-list-item
                    title="TPO Activity/Requests"
                    icon="fa-message-check"
                    @click="$openCard('user-account-requests', {userId: user.id}, card)"
                    :active="isActive('user-account-requests')"
                />

                <navigation-list-item
                    title="Study Log Viewer"
                    icon="fa-book-reader"
                    @click="$openCard('user-study-log', {userId: user.id}, card)"
                    :active="isActive('user-study-log')"
                />

                <separator-list-item />
            </card-list>

            <card-list :class="{'mb-3': user.enrollments.length === 0}">
                <subheader-list-item title="Enrollments" icon="fa-chalkboard-teacher" :badge="user.enrollments.length" />
                <course-enrollment-tile
                    :enrollment="e"
                    :card="card"
                    v-for="e in user.enrollments"
                    :active="(child && child.definition.component === 'edit-enrollment' && e.id === parseInt(child.props.enrollId))"
                    @click="adminOpenCard('edit-enrollment', {enrollId: e.id})"
                />
            </card-list>
            <card-list :class="{'mb-3': user.registrations.length === 0}">
                <subheader-list-item title="Registrations" icon="fa-presentation" :badge="user.registrations.length" />
                <user-registration-tile
                    :registration="r"
                    :card="card"
                    v-for="r in user.registrations"
                    @click="adminOpenCard('registration', {regId: r.id, confId: r.conference_id})"
                    :active="(child && child.definition.component === 'registration' && r.id === parseInt(child.props.regId))"
                />
            </card-list>

            <card-list :class="{'mb-3': user.payment_plans.length === 0}">
                <subheader-list-item title="Payment Plans" icon="fa-money-check-alt" :badge="user.payment_plans.length" />
                <plan-tile
                    :plan="p"
                    :card="card"
                    v-for="p in user.payment_plans"
                    @click="adminOpenCard('payment-plan', {planId: p.id})"
                    :active="(child && child.definition.component === 'payment-plan' && p.id === parseInt(child.props.planId))"
                />
            </card-list>

            <card-list :class="{'mb-3': user.user_certification.length === 0}">
                <subheader-list-item title="Certifications" icon="fa-certificate" :badge="user.user_certification.length" />
                <card-list-item v-for="cert in user.user_certification">
                    <template v-slot:icon><i class="far fa-certificate fa-fw"></i></template>
                    <template v-slot:content>
                        <div class="tile-title">{{cert.certifications.title}}</div>
                        <div class="meta mt-1"><i class="fas fa-barcode mr-2 fa-fw"></i>{{cert.certification_number}}</div>
                    </template>
                </card-list-item>
            </card-list>

            <card-list :class="{'mb-3': user.user_certs.length === 0}">
                <subheader-list-item title="Certificates" icon="fa-file-certificate" :badge="user.user_certs.length" />
                <card-list-item v-for="cert in user.user_certs">
                    <template v-slot:icon><i class="far fa-file-certificate fa-fw"></i></template>
                    <template v-slot:content>
                        <div class="tile-title">{{cert.certification_certs.title}}</div>
                        <div class="meta mt-1"><i class="fas fa-barcode mr-2 fa-fw"></i>{{cert.last_awarded_at | moment('MMMM Do, YYYY')}}</div>
                    </template>
                </card-list-item>
            </card-list>
        </card-body>

        <card-footer class="has-text-right">
            <span class="is-clickable" @click="$copyText(user.id)"><i class="fal fa-barcode-alt mr-2"></i>{{ user.id }}</span>
        </card-footer>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import moment from "moment";
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import CardContainer from "@/TIER/components/CardContainer";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";

    import {client as http} from '@/http_client';
    import {trackUserOpened} from '@/components/recentUserTracker';
    import SubheaderListItem from "../../TIER/components/SubheaderListItem";
    import CardListItem from "../../TIER/components/CardListItem.vue";
    import DataRow from "../../TIER/components/DataRow.vue";
    import UserRegistrationTile from "../../components/tiles/UserRegistrationTile.vue";
    import CourseEnrollmentTile from "../../components/tiles/CourseEnrollmentTile.vue";
    import PlanTile from "../../components/tiles/PlanTile.vue";

    export default {
        components: {PlanTile, CourseEnrollmentTile, UserRegistrationTile, DataRow, CardListItem, SubheaderListItem, SeparatorListItem, CardFooter, CardToolbar, CardContainer, NavigationListItem, CardList, CardBody, CardHeader},
        props: ['card', 'props', 'child'],
        data() {
            return {
                user: {counts: {}}
            };
        },
        computed: {
            ...mapGetters(['currentUser']),
        },
        methods: {
            reload: function() {
                this.loadUser(true);
            },
            loadUser: function(force) {
                this.$emit('loading', true);
                http.get('users/' + this.props.userId, {force}).then(response => {
                    console.log(response.data.dob, moment.utc(response.data.dob).toISOString());
                    this.user = response.data;
                    this.user.dob = moment.utc(this.user.dob).toISOString();
                    console.log(this.user.dob);
                    this.$emit('title', this.user.first_name + ' ' + this.user.last_name + ' (' + this.user.id + ')');
                    this.$emit('loading', false);
                    this.broadcastUserOpened();
                });
            },
            isActive: function(component) {
                return (this.child && this.child.definition && this.child.definition.component === component);
            },
            openLink: function(link) {
                window.open(link);
            },
            getToken: function() {
                http.get('users/login/' + this.user.id, {force: true}).then(response => {
                    const url = (location.hostname === 'portal.my247ed.com') ? 'https://app.my247ed.com/'
                    : (location.hostname === 'localhost') ? 'http://localhost:8081/'
                    : 'https://app.my247ed.lan/';
                    this.openLink(url + '#/providers/portal/login?token=' + response.data.token);
                });
            },
            grantLegacyAccess: function() {
                http.post('users/' + this.user.id + '/legacy-access').then(response => {
                    this.$copyText(response.data.link);
                    this.user.has_legacy_access = true;
                    this.$buefy.toast.open({message: 'Legacy site access link copied to clipboard', type: 'is-success'});
                });
            },
            revokeLegacyAccess: function() {
                http.delete('users/' + this.user.id + '/legacy-access').then(() => {
                    this.user.has_legacy_access = false;
                    this.$buefy.toast.open({message: 'Legacy site access revoked', type: 'is-success'});
                });
            },
            broadcastUserOpened() {
                try {
                    let admin = this.$store.getters.currentUser;
                    if (!admin) return;
                    let data = {
                        type: 'user_opened',
                        userId: this.user.id,
                        firstName: this.user.first_name,
                        lastName: this.user.last_name,
                        email: this.user.email,
                        openedBy: (admin.firstName || '') + ' ' + (admin.lastName || ''),
                        openedById: admin.id
                    };
                    trackUserOpened(data);
                    this.$socket.sendObj(data);
                } catch (e) {}
            },
            adminOpenCard(card, props) {
                if (this.currentUser.isSuper) {
                    this.$openCard(card, {userId: this.props.userId, ...props}, this.card);
                }
            },
        },
        watch: {
            'props.userId': function() {
                this.loadUser();
            }
        },
        mounted: function() {
            this.loadUser();
        }
    };
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }

    .suspension-banner {
        background-color: #fff;
        padding: 0.5rem;

        .suspension-inner {
            border: 2px solid #dc3545;
            border-radius: 0.375rem;
            padding: 0.75rem 1rem;
            display: flex;
            align-items: flex-start;
            gap: 0.75rem;
        }

        .suspension-icon {
            font-size: 1.25rem;
            color: #dc3545;
            flex-shrink: 0;
        }

        .suspension-body {
            flex: 1;

            .suspension-title {
                font-size: 0.9rem;
                font-weight: 600;
                color: #dc3545;
                margin-bottom: 0.25rem;
            }

            .suspension-text {
                font-size: 0.85rem;
                color: #555;
                line-height: 1.4;
            }
        }
    }
</style>
